import { render, staticRenderFns } from "./ResendVerification.vue?vue&type=template&id=35fb30ae&scoped=true&"
import script from "./ResendVerification.vue?vue&type=script&lang=ts&"
export * from "./ResendVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb30ae",
  null
  
)

export default component.exports